export const customProtocolsContainer = ({ customProtocols }) => customProtocols;
